import { Form, Formik } from "formik";
import TextInput from "../UI/TextInput";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import { ModalDialogFooter } from "../UI/ModalDialog";
import Select from "../UI/Select";
import Radio from "../UI/Radio";
import RadioGroup from "../UI/RadioGroup";
import Checkbox from "../UI/Checkbox";
import { courrierValidationSchema } from "../../models/courrier";
import Editor from "../RichTextEditor/Editor";
import TextArea from "../UI/TextArea";

export default function CourrierForm({
  initialValues,
  onSubmit,
  isCreating = false,
}) {
  return (
    <>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        validationSchema={courrierValidationSchema}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue }) => {
          function setValueHandler(value) {
            setFieldValue("content", value);
          }

          return (
            <Form>
              <RadioGroup>
                <Radio name="status" value="1" label="Actif" />
                <Radio name="status" value="0" label="Brouillon" />
              </RadioGroup>
              {isCreating && (
                <TextInput
                  type="text"
                  name="static_id"
                  label={"Identifiant (static_id)"}
                  mandatory
                />
              )}
              <TextInput type="text" name="nom" label={"Nom"} mandatory />
              <Select name={"type"} disabled={isCreating}>
                <option value={"courrier"}>Courrier</option>
                <option value={"avenant"}>Avenant</option>
                <option value={"conge"}>Congé</option>
                <option value={"caution"}>Caution</option>
              </Select>
              <Select name={"category"}>
                <option value={""}>Vide</option>
                <option value={"impaye"}>Impayé</option>
                <option value={"trouble"}>Trouble</option>
                <option value={"justificatif"}>Justificatif</option>
                <option value={"information"}>Information</option>
                <option value={"meuble"}>Meublé</option>
                <option value={"nu"}>Nu</option>
                <option value={"montant"}>Montant</option>
              </Select>
              <div className="flex gap10 marginT10 marginB10">
                <Checkbox name="is_habitation">Habitation</Checkbox>
                <Checkbox name="is_commercial">Commercial</Checkbox>
                <Checkbox name="is_autre_local">Autre local</Checkbox>
              </div>
              <TextArea type="text" name="text" label="Texte de la carte" />
              <Editor
                defaultValue={values.content}
                onChange={setValueHandler}
              />
              <ModalDialogFooter>
                <FormikSubmitButton>Valider</FormikSubmitButton>
              </ModalDialogFooter>
            </Form>
          );
        }}
      </Formik>
    </>
  );
}
